import axios, { type AxiosInstance } from 'axios';
import { createContext, ReactNode } from 'react';
import { getAccessToken, getAuthState } from '@shared/auth/AuthContext';

const AxiosContext = createContext<AxiosInstance | undefined>(undefined);

export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

axiosInstance.interceptors.request.use(async config => {
  const { isDemo } = getAuthState();

  if (!isDemo) {
    try {
      const token = await getAccessToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error('Failed to get access token:', error);
    }
  }

  if (isDemo) {
    config.headers['X-Demo-Mode'] = 'true';
    const demoEmail = localStorage.getItem('demoUserEmail');

    if (demoEmail) {
      config.headers['X-Demo-Email'] = demoEmail;
    }
  }

  if (import.meta.env.DEV) {
    const impersonateUserId = localStorage.getItem('impersonateUserId');

    if (impersonateUserId) {
      config.headers['X-Impersonate-User'] = impersonateUserId;
    }
  }

  return config;
});

export const AxiosProvider = ({ children }: { children: ReactNode }) => {
  return <AxiosContext.Provider value={axiosInstance}>{children}</AxiosContext.Provider>;
};
